export class StatusItem {
    key: string;
    name: string;

    constructor(obj = null) {
        obj = obj || {};
        this.key = obj.key || '';
        this.name = obj.name || '';
    }
}